export type AnalyticsEvent =
  | {
      name: 'calculator_completed'
      calculatorId: string
      dataVersion: string
      resultSummaryBucket?: string
    }
  | { name: 'page_view'; path: string }
  | { name: 'calculator_reset'; calculatorId: string }
  | { name: 'calculator_shared'; calculatorId: string; dataVersion: string }
  | { name: 'calculator_emailed'; calculatorId: string; dataVersion: string }

export function useAnalytics() {
  function track(event: AnalyticsEvent) {
    const provider = import.meta.env.VITE_ANALYTICS_PROVIDER || 'none'
    if (provider === 'none') return
    if (import.meta.env.DEV) {
      console.log('[analytics]', event)
    }
  }
  return { track }
}
